import React, {Component} from 'react';
import GoogleMapReact from 'google-map-react';
import {MAP_API_KEY} from "./../../config/Config";

const Marker = ({ text }) => <div className="my-map-marker2"><span>{text}</span></div>;

export default class MerchantMap extends Component {

    render() {
        const { lat, lng,name } = this.props;
        const defaultProps = {
            center: {
                lat: parseFloat(lat),
                lng:parseFloat(lng)
            },
            zoom: 16
        };
        return (
            <div style={{ height: '400px', width: '100%' }}>
                <GoogleMapReact
                    bootstrapURLKeys={{ key: MAP_API_KEY }}
                    defaultCenter={defaultProps.center}
                    defaultZoom={defaultProps.zoom}
                >
                    <Marker
                        lat={lat}
                        lng={lng}
                        text={name}
                    />
                </GoogleMapReact>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/map/MerchantMap.js